<script>
  import { ConfigsApp } from "@shopboxai/sb-configs-app";
  import { currentUser } from "../stores";
</script>

<ConfigsApp user={$currentUser.accessToken} />
